import UploadLogo from './upload-logo';

export default UploadLogo;